<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>  
@import '../node_modules/buefy/dist/buefy.css'
</style> 




// WEBPACK FOOTER //
// src/App.vue